import React from "react";
import UnavailableSection from "components/UnavailableSection";

/**
 * Was rendering four hardcoded Stockholm addresses, with a delete button that
 * called navigate(id) instead of deleting.
 *
 * Unlike a client, a staff member is an org member rather than a contact:
 * DCR_OrgMember exposes contactList but no addresses, so there is no read path
 * for this tab until one is added.
 */
const AddressesList = () => (
  <UnavailableSection
    title="Addresses are not available yet"
    reason="Staff records expose no address list on the API - DCR_OrgMember carries contacts only."
  />
);

export default AddressesList;
